import {
  createSlice,
  createAsyncThunk,
  PayloadAction,
  createSelector,
} from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import { TransmissionListListItem } from '@/models/transmissionList';
import api from '@/shared/api';
import { ENDPOINTS } from '@/shared/constants';
import { mapTransmissionListListItem } from '@/shared/transmissionLists';
import { RootState } from '@/store';

interface TrasmissionListsState {
  transmissionLists: TransmissionListListItem[];
  loading: boolean;
  error: string | null;
}

// Estado inicial
const initialState: TrasmissionListsState = {
  transmissionLists: [],
  loading: false,
  error: null,
};

// Função para buscar itens da API
export const fetchTransmissionLists = createAsyncThunk<TransmissionListListItem[]>(
  'transmissionLists/fetchTransmissionLists',
  async (_, thunkAPI) => {
    try {
      const response = await api.get(ENDPOINTS.TRANSMISSION_LISTS.GET.ALL);

      return (await response.data).map(mapTransmissionListListItem) as TransmissionListListItem[];
    } catch (error: unknown) {
      toast.error('Erro ao listar listas de transmissão');
      let errorMessage = 'Unknown error';

      if (error instanceof Error) {
        errorMessage = error.message;
      }

      return thunkAPI.rejectWithValue(errorMessage);
    }
  }
);

// Slice
const transmissionListsSlice = createSlice({
  name: 'transmissionLists',
  initialState,
  reducers: {
    // Exemplo de reducer adicional, se necessário
    clearError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTransmissionLists.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchTransmissionLists.fulfilled,
        (state, action: PayloadAction<TransmissionListListItem[]>) => {
          state.loading = false;
          state.transmissionLists = action.payload;
        }
      )
      .addCase(fetchTransmissionLists.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

// Exporta ações e reducer
export const { clearError } = transmissionListsSlice.actions;
export default transmissionListsSlice.reducer;

// Selector
export const allClientsTransmissionListSelector = createSelector(
  (state: RootState) => state.transmissionLists.transmissionLists,
  (transmissionLists) =>
    transmissionLists.find(
      (transmissionList) =>
        transmissionList.name === 'Todos clientes' &&
        transmissionList.isDefault
    )
);
